// TRC
export const ITALIC_START = /{{stress_start}}/g;
export const ITALIC_END = /{{stress_end}}/g;
export const BOLD_START = /{{strong_start}}/g;
export const BOLD_END = /{{strong_end}}/g;
export const TRC_BREAK = /{{break}}/g;

// Daze
export const RESPONSE_GAP = /\\{2}%%([0-9]{2})/g;
export const ESCAPE_QUOTE = /\\"/g;
export const DAZE_BREAK = /\\break\\/g;
export const DAZE_ITALIC_START = /\\italic_start\\/g;
export const DAZE_ITALIC_END = /\\italic_end\\/g;

// Vocab
export const BETWEEN_PERCENTAGE_CHARACTER = /%(.*?)%/;
export const VOCAB_BREAK = /{{break}}/g;
